export default {
  VERIFY_NIP_COMMAND_SERVICE: Symbol.for('VERIFY_NIP_COMMAND_SERVICE'),
  VERIFY_NIP_REPOSITORY: Symbol.for('VERIFY_NIP_REPOSITORY'),
};
